import React, { Fragment, useEffect, useState } from "react";
import home from "../../assets/images/dashboard-home.svg";
import wallet from "../../assets/images/wallet.svg";
import transactions from "../../assets/images/transactions.svg";
import card from "../../assets/images/card.svg";
import dollar from "../../assets/images/dollar.svg";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as httpService from "../../services/httpService";
import { Employee_Api_EndPoints } from "../../global/end-points";
import NoDoughCardMessage from "./nodoughcard_message";
import PrivilegeService from '../../services/PrivilegeService';
import useActivityLogger from "../../utils/useActivityLogger"; // ✅ import logger

const webModule = 'DoughPay';

function MenuComponent() {
  const { t } = useTranslation();
  const [isError, setIsError] = useState(false);
  const [exceptionMsg, setExceptionMsg] = useState({ title: "warning", content: "This is a sample content" });
  const [loading, setLoading] = useState(!sessionStorage.getItem('Privileges'));

  const { logActivity } = useActivityLogger({ moduleCode: "DPY" }); // ✅ moduleCode = Menu
  const isOBO = !!sessionStorage.getItem("OnBehalfUserId");

  // Always get privileges object from sessionStorage and parse it
  const privilegesObj = JSON.parse(sessionStorage.getItem('Privileges') || '{}');

  useEffect(() => {
    if (!sessionStorage.getItem("Privileges")) {
     const phoneNumber = isOBO
       ? sessionStorage.getItem("OnBehalfPhoneNumber")
       : sessionStorage.getItem("phoneNumber");

     PrivilegeService.fetchPrivileges(phoneNumber, webModule)
       .then(() => {
         setLoading(false);
       })
       .catch(() => setLoading(false));
   }
  }, []);

  const getVirtualToken = (e) => {
    e.preventDefault();
    if (sessionStorage.UserId != undefined) {
      const body = {
        UserId: Number(sessionStorage.UserId),
      };
      httpService.Get(Employee_Api_EndPoints.GET_VIRTUAL_CARD_TOKEN, body)
        .then((resp) => {
          const url = new URL(resp.data.url);
          const params = new URLSearchParams(url.search);
          let virtualToken = params.get("Token");
          if (virtualToken !== "") {
            window.open(resp.data.url);

            // ✅ log virtual card access
            logActivity({
              activity: "VIRTUAL_CARD",
              description: `${isOBO ? "OBO-" : ""}Accessed Virtual Card`,
              component: `${isOBO ? "OBO.MENU.VirtualCard" : "MENU.VirtualCard"}`,
            });
          } else {
            setErrorMessage();
          }
        }, () => {
          console.log('error occured !');
          logActivity({
            activity: "VIRTUAL_CARD_ERROR",
            description: `${isOBO ? "OBO-" : ""}Failed to access Virtual Card`,
            component: `${isOBO ? "OBO.MENU.VirtualCard" : "MENU.VirtualCard"}`,
          });
        })
    }
  }

  const setErrorMessage = () => {
    setExceptionMsg({ title: "Message", content: "Your DoughCard creation is pending, this may take few minutes. If it takes too long please contact 'Instadough Techsupport'" });
    setIsError(true);
  }

  const handleClosePopup = () => {
    setIsError(false);
  }

  // List all possible menu items with their module names and routes
  const ALL_MENU_ITEMS = [
    { label: t("DhCrd"), moduleName: 'DoughCard', icon: card, to: "/doughcard" },
    { label: t("Instant Access"), moduleName: 'DoughSummary', icon: card, to: "/doughsummary" },
    { label: t("RecentTrns"), moduleName: 'Transactions', icon: transactions, to: "/transactions" },
    { label: t("PayData"), moduleName: 'Paysheet', icon: dollar, to: "/paysheet" },
    { label: t("VirtualCard"), moduleName: 'VirtualCard', icon: card, isVirtual: true },
  ];

  return (
    <Fragment>
      <div className="dashboard-left">
        <div className="menu-wrapper">
          {/* Home is always visible */}
          <NavLink
            className={(navData) => "menu-item " + (navData.isActive ? "active" : "none")}
            to="/home"
            onClick={() =>
              logActivity({
                activity: "NAVIGATION",
                description: `${isOBO ? "OBO-" : ""}Navigated to Home`,
                component: `${isOBO ? "OBO.MENU.Home" : "MENU.Home"}`,
              })
            }
          >
            <span>
              <img src={home} alt="" className="menu-icon" />
            </span>
            {t("Home")}
          </NavLink>

          {/* Dynamically render allowed menu items */}
          {/* Dynamically render allowed menu items */}
          {ALL_MENU_ITEMS.filter(item =>
            item.moduleName === "Transactions" || item.moduleName === "DoughSummary" ||item.moduleName === "Timesheet" ||
            PrivilegeService.hasReadAccess(privilegesObj, item.moduleName)
          ).map(item => {
            if (item.isVirtual) {
              return (
                <a
                  className={"menu-item" + (loading ? " disabled" : "")}
                  onClick={!loading ? getVirtualToken : undefined}
                  key={item.moduleName}
                  style={{ opacity: !loading ? 1 : 0.5, pointerEvents: !loading ? 'auto' : 'none' }}
                >
                  <span>
                    <img src={item.icon} alt="" className="menu-icon" />
                  </span>
                  {item.label}
                </a>
              );
            }
            return (
              <NavLink
                className={(navData) =>
                  "menu-item " +
                  (navData.isActive ? "active" : "none") +
                  (loading ? " disabled" : "")
                }
                to={item.to}
                key={item.moduleName}
                style={{
                  opacity: !loading ? 1 : 0.5,
                  pointerEvents: !loading ? "auto" : "none",
                }}
                tabIndex={!loading ? 0 : -1}
                onClick={() =>
                  logActivity({
                    activity: "NAVIGATION",
                    description: `${isOBO ? "OBO-" : ""}Navigated to ${item.moduleName}`,
                    component: `${isOBO ? `OBO.MENU.${item.moduleName}` : `MENU.${item.moduleName}`}`,
                  })
                }
              >
                <span>
                  <img src={item.icon} alt="" className="menu-icon" />
                </span>
                {item.label}
              </NavLink>
            );
          })}


          {/* Help is always visible */}
          <NavLink
            className={(navData) => "menu-item " + (navData.isActive ? "active" : "none")}
            to="/helppage"
            onClick={() =>
              logActivity({
                activity: "NAVIGATION",
                description: `${isOBO ? "OBO-" : ""}Navigated to Help`,
                component: `${isOBO ? "OBO.MENU.Help" : "MENU.Help"}`,
              })
            }
          >
            <span>
              <img src={wallet} alt="" className="menu-icon" />
            </span>
            {t("Help")}
          </NavLink>
        </div>
      </div>
      {isError && <NoDoughCardMessage title={exceptionMsg.title} message={exceptionMsg.content} onClose={handleClosePopup} />}
    </Fragment>
  );
}
export default MenuComponent;
